import React from 'react';
import { Button } from 'semantic-ui-react';
import moment from 'moment';

export function formatYesNo(cellInfo) {
  if (!cellInfo.value) {
    return <span>NO</span>;
  }

  return <span>YES</span>;
}

export function formatPatientName(cellInfo) {
  return (
    <span>
      <PatientName admission={cellInfo.original} />
    </span>
  );
}

export function formatAttendingPhysicianName(cellInfo) {
  return (
    <Name
      firstName={cellInfo.original.attending_physician_first_name}
      lastName={cellInfo.original.attending_physician_last_name}
      middleInitial={cellInfo.original.attending_physician_middle_initial}
    />
  );
}

export function formatAdmittingPhysicianName(cellInfo) {
  return (
    <Name
      firstName={cellInfo.original.admitting_physician_first_name}
      lastName={cellInfo.original.admitting_physician_last_name}
      middleInitial={cellInfo.original.admitting_physician_middle_initial}
    />
  );
}

export function formatReviewButton(cellInfo, handler) {
  return (
    <Button
      data-entity-id={cellInfo.entity_id}
      data-admission-id={cellInfo.admission_id}
      size='mini'
      onClick={(e) => handler(e, cellInfo)}
    >
      Open
    </Button>
  );
}

export function formatDateTime(cellInfo) {
  if (!cellInfo.value) {
    return <span></span>;
  }

  return <span>{moment.utc(cellInfo.value).format('MM/DD/YYYY HH:mm')}</span>;
}

export function formatDate(cellInfo) {
  if (!cellInfo.value) {
    return <span></span>;
  }

  return <span>{moment.utc(cellInfo.value).format('MM/DD/YYYY')}</span>;
}

export function formatCircularScore(cellInfo) {
  if (!cellInfo.value) {
    return <span></span>;
  }

  if (cellInfo.value === 1) {
    return <span className='ui label green empty circular'></span>;
  }

  if (cellInfo.value === 2) {
    return <span className='ui label yellow empty circular'></span>;
  }

  return <span className='ui label red empty circular'></span>;
}

const PatientName = ({ admission }) => {
  const patientName =
    admission.patient_last_name + ', ' + admission.patient_first_name;

  return <span>{patientName}</span>;
};

const Name = ({ firstName, lastName, middleInitial }) => {
  if (!firstName || !lastName) {
    return <span></span>;
  }

  let name = lastName + ', ' + firstName;
  if (middleInitial) {
    name += ' ' + middleInitial + '.';
  }

  return <span>{name}</span>;
};
